import React, {useLayoutEffect, useRef, useState} from "react";
import {
    bubbleConvoStartersSelector,
    closeWelcomeBubble,
    defaultPopUpMessageSelector,
    openChatbot,
    sendMessageToBot,
    updateFirstBotMessage,
    updateInitializationType
} from "../../chatbotSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {ConvoStarterButton} from "../Convostarter/ConvoStarterButton";
import {InitializationType, InputType} from "../../../api/generated";

export const WelcomeBubble: React.FC = () => {
    const convoStartFirstMessage = useAppSelector(defaultPopUpMessageSelector) || "Got a question? I am here to help! ";
    const starters = useAppSelector(bubbleConvoStartersSelector) || [];
    const dispatch = useAppDispatch();
    const [userMessage, setUserMessage] = useState("");
    const containerRef = useRef(null);
    const [isMultiRow, setIsMultiRow] = useState(false);

    const handleClose = () => {
        dispatch(closeWelcomeBubble())
    }

    const handleSendMessage = () => {
        if (userMessage.trim() === "") return;
        dispatch(updateFirstBotMessage(convoStartFirstMessage))
        dispatch(openChatbot());
        dispatch(updateInitializationType(InitializationType.OnSendingMessageFromModal))
        dispatch(sendMessageToBot({message: userMessage, inputType: InputType.Button}));
        setUserMessage("");
    }

    const handleConvoStarterClick = (starter: string) => {
        dispatch(updateFirstBotMessage(convoStartFirstMessage))
        dispatch(openChatbot());
        dispatch(updateInitializationType(InitializationType.OnButtonClick))
        dispatch(sendMessageToBot({message: starter, inputType: InputType.Button}));
    }

    useLayoutEffect(() => {
        function checkMultiRow() {
            // @ts-ignore
            if (containerRef.current?.children?.length) {
                // @ts-ignore
                const children = containerRef.current.children;
                const firstRowTop = children[0].offsetTop;
                const multiRow = Array.from(children).some(
                    // @ts-ignore
                    (child) => child.offsetTop > firstRowTop
                );
                setIsMultiRow(multiRow);
            }
        }

        checkMultiRow();

        window.addEventListener("resize", checkMultiRow);
        return () => window.removeEventListener("resize", checkMultiRow);
    }, []);

    const getConvoStarters = () => {
        return isMultiRow ? [...starters].sort((a, b) => a.length - b.length) : starters;
    }

    return (
        <div
            className="relative bg-white rounded-xl text-gray-900 p-4 px-3 pt-8
                 w-full mb-4"
            style={{overflow: "visible", boxShadow: "0 0 8px 4px rgba(0, 18, 46, 0.16)"}}
        >
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                }}
                className="absolute top-2 right-2 w-6 h-6 rounded-full bg-white text-gray-700
                   text-xl flex items-center justify-center hover:bg-gray-200"
            >
                &times;
            </button>

            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
                <img
                    src="/aime-assistant.png"
                    alt="Aime"
                    className="w-14 h-14 rounded-full shadow-sm border-2 border-white bg-[#D9A63F]"
                />
            </div>

            <div className="mt-2 mb-2 px-2 flex flex-col items-center justify-center text-center">
                <h2 className="text-base font-semibold mb-1">
                    Hi, I'm Aime <span role="img" aria-label="wave">👋</span>
                </h2>
                <p className="text-sm leading-snug">
                    {convoStartFirstMessage}
                </p>
            </div>
            {starters.length > 0 &&
                (<div className={`mt-2 flex flex-row flex-wrap gap-2 ${isMultiRow ? "justify-end" : "justify-center"}`}
                      ref={containerRef}>
                        {getConvoStarters().map((starter: string, index: number) =>
                            <ConvoStarterButton key={index}
                                                starter={starter}
                                                handleConvoStarterClick={handleConvoStarterClick}
                                                extraClasses={!isMultiRow ? "flex-grow" : ""}/>
                        )}
                    </div>
                )}
            <div className="mt-3 w-full relative">
                <input
                    type="text"
                    placeholder="Type your message..."
                    value={userMessage}
                    onChange={(e) => setUserMessage(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSendMessage()
                        }
                    }}
                    className="w-full border border-gray-300 bg-[#F8F8F8] text-gray-900 placeholder-gray-600 rounded-[8px] py-3 px-3 pr-10 focus:outline-none"
                    onFocus={(e) => {
                        e.stopPropagation();
                    }}
                />
                <button
                    className="absolute top-1/2 -translate-y-1/2 right-4 flex items-center"
                    onClick={handleSendMessage}
                >
                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 16V10L8.5 8L0.5 6V0L19.5 8L0.5 16Z" fill="black"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};
